import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";

const FeatureTile = ({ feature, width, display }) => {
  const theme = useTheme();
  const { primary, secondary, warning, success } = theme.palette;
  const colors = [primary.main, secondary.main, warning.main, success.main];
  const color = colors[feature?.id - 1];
  return (
    <Box
      key={feature.id}
      mx={"auto"}
      mb={2}
      width={width}
      height={340}
      borderRadius={5}
      sx={{ color: (theme) => theme.palette.common.white }}
    >
      <Grid height={"100%"} container>
        <Grid
          bgcolor={color}
          display={"flex"}
          flexDirection={"column"}
          justifyContent="space-around"
          md={7}
          p={5}
          sx={{
            borderTopLeftRadius: (theme) => theme.spacing(2),
            borderBottomLeftRadius: (theme) => theme.spacing(2),
          }}
        >
          <Box
            sx={{
              background: (theme) => theme.palette.common.white,
              width: (theme) => theme.spacing(7),
              height: (theme) => theme.spacing(7),
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            color={color}
            borderRadius={"50%"}
            fontSize={30}
            fontWeight={600}
          >
            <span style={{ display: "flex", justifyContent: "center" }}>
              {feature?.id}
            </span>
          </Box>
          <Box>
            <Typography fontSize={28} fontWeight={600}>
              {feature?.title}
            </Typography>
            <Typography display={display} fontSize={14} fontWeight={300}>
              {feature?.desc}
            </Typography>
          </Box>
        </Grid>
        <Grid
          sx={{
            backgroundImage: `url(${feature?.img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderTopRightRadius: (theme) => theme.spacing(2),
            borderBottomRightRadius: (theme) => theme.spacing(2),
          }}
          md={5}
        />
      </Grid>
    </Box>
  );
};

export default FeatureTile;
